module.exports = __webpack_public_path__ + "static/protection-cf02c17b479b74c17db14dd10dad42c6.svg";